import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { IrisAuthenticationState } from '../authentication/model';
import { LockOverlayState as model } from './model';
import pattern from '../../assets/images/ExpoEastFlowerLock.png';
import beaconLogoLock from '../../assets/images/beacon-logo-lock.png';
import './LockOverlayComponent.scss';
import { ButtonComponent } from '../UI/ButtonComponent/ButtonComponent';
import { AppActions } from '../../redux/AppActions';
import { RootState } from '../../redux/AppReducer';
import { convertUserLocalStorageKey, lastUrlLocalStorageKey } from '../../common/constants';
import { useAppDispatch } from '../../redux/store';

const LockOverLayComponent: FC = () => {
	const dispatch = useAppDispatch();
	const hasAnonymousEnded = useSelector(
		({ appState: state }: RootState) => state.userState?.hasAnonymousEnded
	);
	const clearModalContent = () => dispatch(AppActions.setModalContent(undefined));
	useEffect(() => {
		const closeIcon = document.getElementById('close-popup');
		if (closeIcon) closeIcon.classList.add('lock-popup-close');
		return () => {
			dispatch(AppActions.setHasAnonymousEnded(undefined));
			if (closeIcon) closeIcon.classList.remove('lock-popup-close');
		};
	}, []);

	const handleLogin = () => {
		localStorage.setItem(
			lastUrlLocalStorageKey,
			window.location.pathname + window.location.search + window.location.hash
		);
		clearModalContent();
		document.getElementById(IrisAuthenticationState.iirisLoginButtonId)?.click();
	};
	const handleRegister = () => {
		localStorage.setItem(
			lastUrlLocalStorageKey,
			window.location.pathname + window.location.search + window.location.hash
		);
		clearModalContent();
		localStorage.setItem(convertUserLocalStorageKey, 'true');
		document.getElementById(IrisAuthenticationState.iirisRegisterButtonId)?.click();
	};
	return (
		<div className='lock-overlay-container'>
			<div className='title-container'>
				<span className='lock-title'>{model.title}</span>
			</div>
			<div className='body-container'>
				<div className='img-container'>
					<img src={beaconLogoLock} alt='beacon-logo' />
				</div>
				<div className='description-container'>
					<i className='ri-checkbox-circle-line'></i>
					<div className='description-content'>
						<span className='description'>
							{hasAnonymousEnded ? model.anonymousEndedText : model.lockedBodyText}
						</span>
					</div>
				</div>
				<div className='buttons-container'>
					<ButtonComponent text={'Login'} onClick={handleLogin} style={'rounded-button primary'} />
					<ButtonComponent
						text={'Sign Up'}
						onClick={handleRegister}
						style={'rounded-button secondary'}
					/>
				</div>
				<img src={pattern} className='back-pattern' alt='back-pattern' />
			</div>
		</div>
	);
};

export default LockOverLayComponent;
